import React from 'react';
import PropTypes from 'prop-types';

function ErrorFallback({ error, resetErrorBoundary }) {
  return (
    <div className="error-fallback d-flex flex-column align-items-center justify-content-center min-vh-100">
      <div className="text-danger mb-4">
        <i className="bi bi-exclamation-triangle-fill fs-1"></i>
      </div>
      <h2 className="mb-3">Something went wrong</h2>
      <p className="text-muted mb-4">We&apos;re sorry, but an unexpected error has occurred.</p>
      {error && process.env.NODE_ENV === 'development' && (
        <div className="alert alert-danger mb-4">
          <p className="fw-bold">Error details:</p>
          <p className="mb-0">{error.message}</p>
        </div>
      )}
      <button onClick={resetErrorBoundary} className="btn btn-primary">
        Try again
      </button>
    </div>
  );
}

ErrorFallback.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string,
  }),
  resetErrorBoundary: PropTypes.func.isRequired,
};

export default ErrorFallback;
